<div data-cy="attachments-list">
    <div class="label-wrapper">
        <span class="label" data-cy="attachments-list-title">Attachments</span>
        <button (click)="refreshAttachments()"
                class="btn-text-link btn-refresh"
                data-cy="claim-information-attachments-button-refresh">
            <span class="iwp-icon-gen_refresh icon-refresh"></span>
            <span>Refresh</span>
        </button>
    </div>
    <span data-cy="attachments-list-content">
    <div class="file-list-item" data-cy="file-list-item">
        <app-file-preview [fileManagerOffline]=fileManagerOffline [extension]=extension></app-file-preview>
        <div class="file-info">
            <span class="file-info name" data-cy="file-list-item-name">Please use the refresh button to reattempts a communication.</span>
        </div>
    </div>
    </span>
</div>
